var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazonLogoWobLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pexels-italo-melo-2379004",
    x: -20,
    y: -16,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#333",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#pexels-italo-melo-2379004)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pexels-italo-melo-2379004-2",
    "data-name": "pexels-italo-melo-2379004",
    width: 30,
    height: 30,
    rx: 10,
    transform: "translate(0.38 0.38)",
    fill: "#feb730"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_340",
    "data-name": "Mask Group 340",
    transform: "translate(-0.385 -0.385)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M.058,23.169C.151,23.02.3,23.01.5,23.141A29.809,29.809,0,0,0,15.729,27.2a30.133,30.133,0,0,0,10.834-2.046l.4-.18c.177-.077.3-.128.376-.167a.517.517,0,0,1,.674.167c.154.223.115.431-.154.616-.328.244-.77.526-1.29.839a20.809,20.809,0,0,1-5.367,2.214A22.6,22.6,0,0,1,7.159,27.9,22.933,22.933,0,0,1,.2,23.607.387.387,0,0,1,0,23.325a.278.278,0,0,1,.064-.167Zm8.421-7.975a5.636,5.636,0,0,1,.953-3.3,5.863,5.863,0,0,1,2.616-2.071,14.187,14.187,0,0,1,3.735-.923c.5-.059,1.324-.132,2.463-.223V8.2a5.138,5.138,0,0,0-.385-2.405,2.1,2.1,0,0,0-1.847-.834h-.233a3.081,3.081,0,0,0-1.6.59,2.324,2.324,0,0,0-.866,1.406.719.719,0,0,1-.557.654L9.527,7.2c-.318-.077-.477-.231-.477-.5a.785.785,0,0,1,.028-.192,5.392,5.392,0,0,1,2.334-3.694A8.975,8.975,0,0,1,15.761,1.47h.693A7.12,7.12,0,0,1,21.44,3.124c.174.192.346.385.52.616a3.279,3.279,0,0,1,.363.577,2.46,2.46,0,0,1,.25.731c.077.326.135.539.174.654a3.694,3.694,0,0,1,.1.788c.013.4.026.633.026.71v6.772A4.194,4.194,0,0,0,23.08,15.3a3.051,3.051,0,0,0,.4.864l.654.864a.874.874,0,0,1,.174.462.494.494,0,0,1-.231.4c-1.539,1.347-2.386,2.078-2.518,2.193a.749.749,0,0,1-.808.058,7.775,7.775,0,0,1-.675-.636l-.4-.445q-.211-.264-.407-.539l-.385-.557a6.88,6.88,0,0,1-3.078,2.136,8.106,8.106,0,0,1-2.347.292,4.924,4.924,0,0,1-3.54-1.326A4.968,4.968,0,0,1,8.541,15.3l-.064-.1Zm4.814-.562a2.653,2.653,0,0,0,.545,1.749,1.843,1.843,0,0,0,1.481.657,1.947,1.947,0,0,0,.25-.026,1.438,1.438,0,0,1,.213-.03,2.879,2.879,0,0,0,1.826-1.511,4.059,4.059,0,0,0,.462-1.167,5.042,5.042,0,0,0,.174-1.026c.019-.25.019-.693.019-1.289V11.3a9.92,9.92,0,0,0-2.463.231,3.006,3.006,0,0,0-2.463,3.117l-.045-.026Zm11.751,9.012a.919.919,0,0,1,.169-.218,4.581,4.581,0,0,1,1.347-.641,10.381,10.381,0,0,1,2.068-.308,1.705,1.705,0,0,1,.526.038c.834.077,1.347.215,1.5.423a.889.889,0,0,1,.115.5v.192a6.415,6.415,0,0,1-.532,2.309,5.584,5.584,0,0,1-1.483,2.155.422.422,0,0,1-.252.115.3.3,0,0,1-.115-.015c-.115-.056-.138-.154-.082-.308A10.523,10.523,0,0,0,29.341,24.5a.732.732,0,0,0-.112-.441c-.186-.213-.705-.33-1.57-.33-.311,0-.684.021-1.116.059-.465.058-.9.115-1.283.174a.34.34,0,0,1-.231-.056c-.038-.038-.046-.061-.026-.1a.213.213,0,0,1,.026-.081v-.077Z",
    transform: "translate(-0.003 -0.063)",
    fill: "#feb730"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonLogoWobLg);
export default __webpack_public_path__ + "static/media/amazon_logo_wob_lg.9e783e5ffe4d255aa3b424b49bd43acc.svg";
export { ForwardRef as ReactComponent };